import { render, staticRenderFns } from "./waves.vue?vue&type=template&id=be00e5b2"
import script from "./waves.vue?vue&type=script&lang=js"
export * from "./waves.vue?vue&type=script&lang=js"
import style0 from "./waves.vue?vue&type=style&index=0&id=be00e5b2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports